module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


// WEBPACK FOOTER //
// ../node_modules/babel-runtime/core-js/symbol.js